import axios from "axios";
import api from "./api";

const ENV_PAYBOX = 'prod'
const BASE_URL = 'https://api3.micasitaapp.com'

class ParkService {
  static async getParking(form) {
    try {
      const data = {
        search: form.value,
        conjunto: form.conjunto,
        ambiente: ENV_PAYBOX
      };
      const res = await api.post(`ParkeyCostos`, data);
      return {
        id: res.id,
        conjunto: form.conjunto,
        name: res.nombre_persona_ingreso,
        lastname: res.apellido_persona_ingreso,
        dni: res.cedula_persona_ingreso,
        plate: res.placa_vehiculo_ingreso,
        color: res.color_vehiculo_ingreso,
        ticket: res.numero_ticket,
        dateIn: new Date(res.hora_entrada),
        dateOut: res.hora_salida ? new Date(res.hora_salida) : null,
        fee: res.costo_hora,
        hasPaybox: res.has_paybox,
        value0: res.paybox_base_0,
        value12: res.paybox_base_12,
        tiempo_base: res.tiempo_base,
        images: {
          face: res.imagen_rostro,
          car: res.imagen_vehiculo,
          dni: res.imagen_cedula,
          plate: res.imagen_placa,
          faceOut: res.imagen_rostro_salida,
          carOut: res.imagen_vehiculo_salida,
          dniOut: res.imagen_cedula_salida
        }
      }
    } catch (error) {
      if (error.data) {
        throw Error(error.data);
      }
      throw Error(error.message);
    }
  }

  static async getPayUrl(form) {
    try {
      const res = await api.post(`PagosPluxUser`, {
        "ambiente": ENV_PAYBOX,
        "conjuntoId": form.conjunto,
        "base0": form.value0,
        "base12": form.value12,
        "nombre": form.nombre,
        "apellido": form.apellido,
        "correo": form.correo,
        "descripcion": form.descripcion
      });

      return res.urlPaybox;
    } catch (error) {
      if (error.data) {
        throw Error(error.data);
      }
      throw Error(error.message);
    }
  }

  static async getComplexes() {
    try {
      const res = await api.post('ParkeyConjuntos')
      return res
    } catch (error) {
      if (error.data) {
        throw Error(error.data);
      }
      throw Error(error.message);
    }
  }

  static async postProcessPay(form) {
    try {
      const endpoint = `/parkey/${form.conjunto}/${form.id}/process_pay/`
      const res = await axios.post(endpoint, {
        valor: form.valor,
        comprobante: form.comprobante,
        usuario: form.usuario,
        dni: form.dni,
        correo: form.correo,
        portalRes: form.portalRes
      }, {
        headers: { "Version": "v3" },
        baseURL: BASE_URL
      });
      return res.data;
    } catch (error) {

      if (error.response) {
        throw Error(error.response.data.msg);
      }
      throw Error(error.message);
    }
  }
}

export default ParkService;
